"use client"
import React, { useState, useEffect, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import { useRouter, useSearchParams } from "next/navigation";

import useApi from "@/components/api/useApi";
import MapAndPins from "@/components/maps/MapAndPins";

import "@/components/maps/embed/EmbeddedStoryMapListWidget.css";

const EmbeddedStoryMapListWidget = props => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [denied, setDenied] = useState(false);
  const [map, setMap] = useState(null);
  const [points, setPoints] = useState(null);

  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });

  const api = useApi();

  const profileName = props.match.params.name;
  const key = searchParams.get("key");

  const fetchMap = async props => {
    const mapId = props.match.params.mid;

    if (key != null && key !== "") {
      await api
        .getProfileMapPointsWithToken(profileName, mapId, key, "Client")
        .then(points => {
          setPoints(points);
        });
      await api
        .getProfileMapWithToken(profileName, mapId, key, "Client")
        .then(map => {
          setMap(map);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          setDenied(true);
        });
    } else {
      setLoading(false);
      setDenied(true);
    }
  };

  useEffect(() => {
    fetchMap(props);
  }, [key, profileName]);

  useEffect(() => {
    if (denied) router.replace("/403");
  }, [denied, router]);

  if (loading) {
    return <></>;
  } else if (denied) {
    return null;
  } else {
    return (
      <div className="embedded-map-list-widget sticky-map">
        <MapAndPins
          name={profileName}
          mapView={map}
          points={points}
          showProgress={true}
          external={true}
          welcomeMessage={true}
          appendIntroduction={true}
        />
      </div>
    );
  }
};

export default EmbeddedStoryMapListWidget;
